import { Component } from "react";
import Button from "@material-ui/core/Button";
import { generatePainFileWithCurrency } from "../../../../utilities/generatePainFile";

export default class WithdrawTableButtons extends Component {
  constructor(props) {
    super(props);

    this.state = { open: false, selected: [], PayoutDate: null, error: "" };
  }

  triggerPainFilePicker = () => {
    this.inputElement.click();
  };

  setError = (error) => {
    this.setState({ error: error });
  };

  onChangeHandler = (ev) => {
    let file = ev.target.files[0];
    let fileReader = new FileReader();
    fileReader.onload = () => {
      let parser = new DOMParser();
      let result = fileReader.result;
      let xmlDoc = parser.parseFromString(result, "text/xml");
      let list = [];
      let selectors = xmlDoc.querySelectorAll("PmtInfId");
      for (let idx = 0; idx < selectors.length; idx++) {
        let selector = selectors[idx];
        let withdrawalId = selector.textContent.substr(11);
        let item = this.props.items.find((o) => {
          return o.IntId == withdrawalId;
        });
        if (item) list.push(item);
      }
      this.props.approveWithdrawalOrders(list);
    };
    fileReader.readAsText(file);
  };

  render() {
    return (
      <div>
        {!this.props.isMpl && (
          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              generatePainFileWithCurrency(
                this.props.getSelected(),
                this.props.currency,
                "/withdrawal-pain",
                this.setError,
              )
            }
            style={{ marginRight: "3px" }}
          >
            Generate pain file (includes AML warning withdrawals as well)
          </Button>
        )}
        <input
          id="filePainWithdrawalConfirmation"
          type="file"
          name="file"
          onChange={this.onChangeHandler}
          style={{ display: "none" }}
          ref={(input) => (this.inputElement = input)}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={this.triggerPainFilePicker}
        >
          Confirm pain payouts
        </Button>
        <br />
        <div style={{ color: "red" }}>{this.state.error}</div>
      </div>
    );
  }
}
